import { insert as _$insert } from "@opentui/solid";
import { memo as _$memo } from "@opentui/solid";
import { createComponent as _$createComponent } from "@opentui/solid";
import { effect as _$effect } from "@opentui/solid";
import { createTextNode as _$createTextNode } from "@opentui/solid";
import { insertNode as _$insertNode } from "@opentui/solid";
import { setProp as _$setProp } from "@opentui/solid";
import { createElement as _$createElement } from "@opentui/solid";
import { Prompt } from "@tui/component/prompt";
import { createMemo, Match, onMount, Show, Switch } from "solid-js";
import { useTheme } from "@tui/context/theme";
import { useKeybind } from "@tui/context/keybind";
import { Logo } from "../component/logo";
import { Tips } from "../component/tips";
import { Locale } from "@/util/locale";
import { useSync } from "../context/sync";
import { Toast } from "../ui/toast";
import { useArgs } from "../context/args";
import { useDirectory } from "../context/directory";
import { useRouteData } from "@tui/context/route";
import { usePromptRef } from "../context/prompt";
import { Installation } from "@/installation";
import { useKV } from "../context/kv";
import { useCommandDialog } from "../component/dialog-command";

// TODO: what is the best way to do this?
let once = false;
export function Home() {
  const sync = useSync();
  const kv = useKV();
  const {
    theme
  } = useTheme();
  const route = useRouteData("home");
  const promptRef = usePromptRef();
  const command = useCommandDialog();
  const mcp = createMemo(() => Object.keys(sync.data.mcp).length > 0);
  const mcpError = createMemo(() => {
    return Object.values(sync.data.mcp).some(x => x.status === "failed");
  });
  const connectedMcpCount = createMemo(() => {
    return Object.values(sync.data.mcp).filter(x => x.status === "connected").length;
  });
  const isFirstTimeUser = createMemo(() => sync.data.session.length === 0);
  const tipsHidden = createMemo(() => kv.get("tips_hidden", false));
  const showTips = createMemo(() => {
    // Don't show tips for first-time users
    if (isFirstTimeUser()) return false;
    return !tipsHidden();
  });
  command.register(() => [{
    title: tipsHidden() ? "Show tips" : "Hide tips",
    value: "tips.toggle",
    keybind: "tips_toggle",
    category: "System",
    onSelect: dialog => {
      kv.set("tips_hidden", !tipsHidden());
      dialog.clear();
    }
  }]);
  const Hint = _$createComponent(Show, {
    get when() {
      return connectedMcpCount() > 0;
    },
    get children() {
      var _el$ = _$createElement("box"),
        _el$2 = _$createElement("text");
      _$insertNode(_el$, _el$2);
      _$setProp(_el$, "flexShrink", 0);
      _$setProp(_el$, "flexDirection", "row");
      _$setProp(_el$, "gap", 1);
      _$insert(_el$2, _$createComponent(Switch, {
        get children() {
          return [_$createComponent(Match, {
            get when() {
              return mcpError();
            },
            get children() {
              return [(() => {
                var _el$3 = _$createElement("span");
                _$insertNode(_el$3, _$createTextNode(`•`));
                _$effect(_$p => _$setProp(_el$3, "style", {
                  fg: theme.error
                }, _$p));
                return _el$3;
              })(), " mcp errors", " ", (() => {
                var _el$5 = _$createElement("span");
                _$insertNode(_el$5, _$createTextNode(`ctrl+x s`));
                _$effect(_$p => _$setProp(_el$5, "style", {
                  fg: theme.textMuted
                }, _$p));
                return _el$5;
              })()];
            }
          }), _$createComponent(Match, {
            when: true,
            get children() {
              return [(() => {
                var _el$7 = _$createElement("span");
                _$insertNode(_el$7, _$createTextNode(`•`));
                _$effect(_$p => _$setProp(_el$7, "style", {
                  fg: theme.success
                }, _$p));
                return _el$7;
              })(), " ", _$memo(() => Locale.pluralize(connectedMcpCount(), "{} mcp server", "{} mcp servers"))];
            }
          })];
        }
      }));
      _$effect(_$p => _$setProp(_el$2, "fg", theme.text, _$p));
      return _el$;
    }
  });
  let prompt;
  const args = useArgs();
  onMount(() => {
    if (once) return;
    if (route.initialPrompt) {
      prompt.set(route.initialPrompt);
      once = true;
    } else if (args.prompt) {
      prompt.set({
        input: args.prompt,
        parts: []
      });
      once = true;
      prompt.submit();
    }
  });
  const directory = useDirectory();
  const keybind = useKeybind();
  return [(() => {
    var _el$9 = _$createElement("box"),
      _el$0 = _$createElement("box"),
      _el$1 = _$createElement("box"),
      _el$10 = _$createElement("box"),
      _el$11 = _$createElement("box"),
      _el$12 = _$createElement("box"),
      _el$13 = _$createElement("box"),
      _el$14 = _$createElement("box");
    _$insertNode(_el$9, _el$0);
    _$insertNode(_el$9, _el$1);
    _$insertNode(_el$9, _el$10);
    _$insertNode(_el$9, _el$11);
    _$insertNode(_el$9, _el$12);
    _$insertNode(_el$9, _el$13);
    _$insertNode(_el$9, _el$14);
    _$setProp(_el$9, "flexGrow", 1);
    _$setProp(_el$9, "alignItems", "center");
    _$setProp(_el$9, "paddingLeft", 2);
    _$setProp(_el$9, "paddingRight", 2);
    _$setProp(_el$0, "flexGrow", 1);
    _$setProp(_el$0, "minHeight", 0);
    _$setProp(_el$1, "height", 4);
    _$setProp(_el$1, "minHeight", 0);
    _$setProp(_el$1, "flexShrink", 1);
    _$setProp(_el$10, "flexShrink", 0);
    _$insert(_el$10, _$createComponent(Logo, {}));
    _$setProp(_el$11, "height", 1);
    _$setProp(_el$11, "minHeight", 0);
    _$setProp(_el$11, "flexShrink", 1);
    _$setProp(_el$12, "width", "100%");
    _$setProp(_el$12, "maxWidth", 75);
    _$setProp(_el$12, "zIndex", 1000);
    _$setProp(_el$12, "paddingTop", 1);
    _$setProp(_el$12, "flexShrink", 0);
    _$insert(_el$12, _$createComponent(Prompt, {
      ref: r => {
        prompt = r;
        promptRef.set(r);
      },
      hint: Hint
    }));
    _$setProp(_el$13, "height", 4);
    _$setProp(_el$13, "minHeight", 0);
    _$setProp(_el$13, "width", "100%");
    _$setProp(_el$13, "maxWidth", 75);
    _$setProp(_el$13, "alignItems", "center");
    _$setProp(_el$13, "paddingTop", 3);
    _$setProp(_el$13, "flexShrink", 1);
    _$insert(_el$13, _$createComponent(Show, {
      get when() {
        return showTips();
      },
      get children() {
        return _$createComponent(Tips, {});
      }
    }));
    _$setProp(_el$14, "flexGrow", 1);
    _$setProp(_el$14, "minHeight", 0);
    _$insert(_el$9, _$createComponent(Toast, {}), null);
    return _el$9;
  })(), (() => {
    var _el$15 = _$createElement("box"),
      _el$16 = _$createElement("text"),
      _el$17 = _$createElement("box"),
      _el$26 = _$createElement("box"),
      _el$27 = _$createElement("box"),
      _el$28 = _$createElement("text");
    _$insertNode(_el$15, _el$16);
    _$insertNode(_el$15, _el$17);
    _$insertNode(_el$15, _el$26);
    _$insertNode(_el$15, _el$27);
    _$setProp(_el$15, "paddingTop", 1);
    _$setProp(_el$15, "paddingBottom", 1);
    _$setProp(_el$15, "paddingLeft", 2);
    _$setProp(_el$15, "paddingRight", 2);
    _$setProp(_el$15, "flexDirection", "row");
    _$setProp(_el$15, "flexShrink", 0);
    _$setProp(_el$15, "gap", 2);
    _$insert(_el$16, directory);
    _$setProp(_el$17, "gap", 1);
    _$setProp(_el$17, "flexDirection", "row");
    _$setProp(_el$17, "flexShrink", 0);
    _$insert(_el$17, _$createComponent(Show, {
      get when() {
        return mcp();
      },
      get children() {
        return [(() => {
          var _el$18 = _$createElement("text"),
            _el$23 = _$createTextNode(` MCP`);
          _$insertNode(_el$18, _el$23);
          _$insert(_el$18, _$createComponent(Switch, {
            get children() {
              return [_$createComponent(Match, {
                get when() {
                  return mcpError();
                },
                get children() {
                  var _el$19 = _$createElement("span");
                  _$insertNode(_el$19, _$createTextNode(`⊙ `));
                  _$effect(_$p => _$setProp(_el$19, "style", {
                    fg: theme.error
                  }, _$p));
                  return _el$19;
                }
              }), _$createComponent(Match, {
                when: true,
                get children() {
                  var _el$21 = _$createElement("span");
                  _$insertNode(_el$21, _$createTextNode(`⊙ `));
                  _$effect(_$p => _$setProp(_el$21, "style", {
                    fg: connectedMcpCount() > 0 ? theme.success : theme.textMuted
                  }, _$p));
                  return _el$21;
                }
              })];
            }
          }), _el$23);
          _$insert(_el$18, connectedMcpCount, _el$23);
          _$effect(_$p => _$setProp(_el$18, "fg", theme.text, _$p));
          return _el$18;
        })(), (() => {
          var _el$24 = _$createElement("text");
          _$insertNode(_el$24, _$createTextNode(`/status`));
          _$effect(_$p => _$setProp(_el$24, "fg", theme.textMuted, _$p));
          return _el$24;
        })()];
      }
    }));
    _$setProp(_el$26, "flexGrow", 1);
    _$insertNode(_el$27, _el$28);
    _$setProp(_el$27, "flexShrink", 0);
    _$insert(_el$28, () => Installation.VERSION);
    _$effect(_p$ => {
      var _v$ = theme.textMuted,
        _v$2 = theme.textMuted;
      _v$ !== _p$.e && (_p$.e = _$setProp(_el$16, "fg", _v$, _p$.e));
      _v$2 !== _p$.t && (_p$.t = _$setProp(_el$28, "fg", _v$2, _p$.t));
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$15;
  })()];
}